import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { array } from "../../shared/src/codecs/types/array";
import { TTypeOfCodec } from "../../shared/src/codecs/codec";

export const CLCAuditDocumentLink = required({
    document_key: string(),
    url: string(),
});
export type TCLCAuditDocumentLink = TTypeOfCodec<typeof CLCAuditDocumentLink>;

export const CLCAuditDocumentLinks = required({
    links: array(CLCAuditDocumentLink),
});
export type TCLCAuditDocumentLinks = TTypeOfCodec<typeof CLCAuditDocumentLinks>;
